import { Component, PureComponent } from "react";
import { findDOMNode } from "react-dom";
// import { Modal } from "antd";
/* eslint-disable no-invalid-this */

// const componentDidCatch = function(error, info) {
//   // eslint-disable-next-line
//   console.log(`componentDidCatch at ${this.constructor.name}`, "\n Error: \n", error, "\n Info: \n", info);
//
//   Modal.confirm({
//     title: app.translate("main.Something went wrong"),
//     content: app.translate("main.Do you want to report this problem"),
//     onOk() {
//       // eslint-disable-next-line
//     },
//     onCancel() {
//       // eslint-disable-next-line
//     },
//   });
// };

const setState = function(setState) {
  return function(...args) {
    if (this.mounted) {
      setState.call(this, ...args);
    }
  };
};

const forceUpdate = function(forceUpdate) {
  return function(...args) {
    if (this.mounted) {
      forceUpdate.call(this, ...args);
    }
  };
};

// -------------------------------------------------------------------- Component --------------------------------------------------------------------
Component.prototype._unsubscribeReduxState = () => {};

Component.prototype.reduxStateDidUpdate = () => { };

Component.prototype.handleOutsideClick = () => { };

Component.prototype.componentWillMount = function () {
  let prevReduxState = {};
  const handleReduxStateChange = () => {
    const newState = app.state;

    if (!newState.$equals(prevReduxState)) {
      this.reduxStateDidUpdate(newState, prevReduxState);

      prevReduxState = newState;
    }
  };
  this._unsubscribeReduxState = app.subscribe(handleReduxStateChange);

  this._domNode = findDOMNode(this);
  document.addEventListener("click", (event) => {
    if (this._domNode && !this._domNode.contains(event.target)) {
      this.handleOutsideClick(event);
    }
  }, false);

  this.mounted = true;
};

Component.prototype.componentWillUnmount = function () {
  this._unsubscribeReduxState();

  this.mounted = false;
};

// Component.prototype.componentDidCatch = componentDidCatch;

// Component.prototype.setState = (setState(Component.prototype.setState)); // didn't work

// ------------------------------------------------------------------ PureComponent ------------------------------------------------------------------
PureComponent.prototype.setState = (setState(PureComponent.prototype.setState));
PureComponent.prototype.forceUpdate = (forceUpdate(PureComponent.prototype.forceUpdate));
